import { classToPlain, plainToClass } from 'class-transformer';
import { TUserId } from '../../../PartyClientResponse';
import PlayerModel from './PlayerModel';

export enum GameType {
  NONE,
  CHALLENGE,
}

export enum GameState {
  NONE,
  STARTED,
  STOPPED,
}

export function gameStateToString(state: GameState) {
  switch (state) {
    case GameState.NONE:
      return 'NoneGameState';
    case GameState.STARTED:
      return 'StartedGameState';
    case GameState.STOPPED:
      return 'StoppedGameState';
    default:
      return 'Undefined';
  }
}

export function gameTypeToString(type: GameType) {
  switch (type) {
    case GameType.CHALLENGE:
      return 'ChallengeGameType';
    default:
      return 'UNDEFINED';
  }
}

export default class GameModel {
  static fromJson(json: any) {
    return plainToClass(this, json);
  }

  public toJson() {
    return classToPlain(this);
  }

  type!: GameType;
  typeTitle!: string;
  displayName!: string;
  id!: string;
  state!: GameState;
  ownerId!: TUserId;
  winner!: any | null;
}
